const applicationName = "foos-js-resolve"

export default applicationName